import {defineStore} from 'pinia'
import {coordinator, routes} from "@/plugins/axios";

export const useInvitation = defineStore('invitationStore', {
    state: () => ({
        loading: false,
        invitation: {
            uid: null,
            member_uid: null,
            first_name: null,
            last_name: null,
            phone_number: null,
            email: null,
            token: null,
        },
    }),
    actions: {
        async getInvitation(uid, otp) {
            this.loading = true;
            return coordinator.get(routes.invitations.get(uid, otp))
                .then(response => {
                    this.invitation = response.data.data;
                })
                .finally(() => this.loading = false);
        },
        async updateInvitation(uid, otp, invitationData) {
            this.loading = true;
            return coordinator.patch(routes.invitations.update(uid, otp), invitationData)
                .then((response) => {
                    this.invitation = response.data.data;
                })
                .finally(() => this.loading = false);
        },
    },
})
